import { render, staticRenderFns } from "./demo-list.vue?vue&type=template&id=19117d54&scoped=true&"
import script from "./demo-list.vue?vue&type=script&lang=js&"
export * from "./demo-list.vue?vue&type=script&lang=js&"
import style0 from "./demo-list.vue?vue&type=style&index=0&id=19117d54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19117d54",
  null
  
)

export default component.exports